import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { Field, reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import { toastr } from 'react-redux-toastr';
import { InputField, required, email } from '../components/form';
import { Blank as Layout } from '../components/layouts';
import { SessionApi } from '../api';
import { titleize } from '../utils/helpers/text_formatters';

class LoginPage extends Component {

  componentWillMount() {
    const { isAuthenticated, dispatch, redirectTo } = this.props;
    if (isAuthenticated) dispatch(push(redirectTo));
  }

  onFormSubmit(values) {
    const { dispatch, redirectTo, isPublisher, isAdvertiser, isSsp } = this.props;
    let platform = isPublisher ? 'Publisher' : (isAdvertiser ? 'Advertiser' : '');
    platform = isSsp ? 'Ssp' : platform;

    dispatch(SessionApi.actions.auth.post({ ...values, platform }, (_error, success) => {
      if (success) {
       dispatch(push(redirectTo));
       toastr.success('Successfully logged in!');
      }
    }));
  }

  render() {
    const { handleSubmit, isPublisher, isAdvertiser, isSsp, redirect } = this.props;
    let platform = isPublisher ? 'publisher' : 'advertiser';
    platform = isSsp ? 'ssp' : platform;
    const platformClass = `is${titleize(platform)}`;

    const forgotPassword = `/${platform}/forgotpassword`;
    const otherPlatform = isAdvertiser ? 'publisher' : 'advertiser';
    
    const switchPlatform = redirect ? `/${otherPlatform}/login?redirect=${redirect}` :
      `/${otherPlatform}/login`;

    const sspPlatform = redirect ? `/ssp/login?redirect=${redirect}` :
      '/ssp/login';

    const publisherPlatform = redirect ? `/publisher/login?redirect=${redirect}` :
      '/publisher/login';
    return (
      <Layout>
        <div className={`middle-box text-center loginscreen animated fadeIn ${platformClass}`}>
            <div>
                <div>
                    <h1 className='logo-name'>JobAdX</h1>
                </div>

                <h3 style={{ textTransform: 'capitalize' }}>
                  {platform} Dashboard
                </h3>

                <p>Login in. To see it in action.</p>

                <form
                  onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
                  className='m-t text-right'
                >
                  <Field
                    type='text'
                    name='user[email]'
                    placeholder='Email'
                    component={InputField}
                    validate={[required, email]}
                  />

                  <Field
                    type='password'
                    name='user[password]'
                    placeholder='Password'
                    component={InputField}
                    validate={[required]}
                  />

                  <Field name="user[country_code]" component="select" placeholder='Country Code' className="form-control m-b">
                    <option value='US'>US</option>
                    <option value='CA'>CA</option>
                  </Field>

                  <Button
                    type='submit'
                    loading={this.props.isLoading}
                    bsStyle='primary'
                    className='block full-width m-b'
                  >
                    Login
                  </Button>
                  <div className='text-center'>

                     {isSsp ? null : <Link to={forgotPassword}>
                      <small>Forgot password?</small> <br />
                    </Link>}

                    {isSsp ? <Link to={publisherPlatform}>
                      <small>
                          Have a publisher account?
                      </small>
                    </Link> : <Link to={switchPlatform}>
                      <small>
                          Have a(n) {otherPlatform} account?
                      </small>
                    </Link>}
                    <br />
                    {isPublisher ? <Link to={sspPlatform}>
                      <small>
                          Have a ssp account?
                      </small>
                    </Link> : null }
                  </div>

                  <p className='text-muted text-center'>
                    <small>Do not have an account?</small>
                  </p>

                  <a className='btn btn-sm btn-white btn-block' href='https://www.jobadx.com'>
                    Contact Us
                  </a>
                </form>
            </div>
        </div>
      </Layout>
    );
  }
}

const form = reduxForm({
  form: 'LoginForm'
});

const mapStateToProps = (state, ownProps) => {
  const { location: { query: { redirect }, pathname } } = ownProps;
  const { auth: { loading, data: { isAuthenticated } } } = state;

  return {
    isAuthenticated,
    isLoading: loading,
    redirectTo: redirect ? `/initializing?redirect=${redirect}` : '/initializing',
    redirect,
    isSsp: pathname.match(/ssp/i),
    isPublisher: pathname.match(/publisher/i),
    isAdvertiser: pathname.match(/advertiser/i)
  };
};

export default connect(mapStateToProps)(form(LoginPage));
